// extracted by mini-css-extract-plugin
export default {"spinner":"style_spinner__v7MrE","spinning":"style_spinning__D7eGp","text":"style_text__dS8Ny","dark":"style_dark__NW2BM","layout":"style_layout__chGbw"};